import { useContext, useMemo } from 'react';
import { getTranslations } from '../../assets/translations/index.js';
import { LanguageContext } from '../contexts/LanguageContext.js';

export const useLanguageData = (page) => {
	const { lang } = useContext(LanguageContext);

	const pageData = useMemo(() => {
		if (!lang) {
			return {};
		}

		const data = getTranslations(lang);
		const path = page.split('.');
		let result = data[path[0]];

		for (let i = 1; i < path.length; i += 1) {
			result = result?.[path[i]];
		}

		return result ?? {};
	}, [lang, page]);

	return pageData;
};

export const useLanguage = () => {
	const context = useContext(LanguageContext);
	if (!context) {
		throw new Error('useLanguage must be used within LanguageContextProvider');
	}
	return context;
};
